import React from "react";

type CartItemPropertyProps =
  | {
      name: string;
      value?: string;
      productType?: string;
    }
  | {
      name?: string;
      value: string;
      productType?: string;
    };

const CartItemProperty = ({ name, value, productType }: CartItemPropertyProps) => {
  return (
    <div className="cart-item__property">
      {name && productType !== "Free Gift" && (
        <span className="cart-item__property-name">{name}</span>
      )}
      {value && <span className="cart-item__property-value">{value}</span>}
    </div>
  );
};

export default CartItemProperty;
